// Exemplo nova diretiva
// doc: https://012.vuejs.org/guide/custom-directive.html
/*
    export const nomeDiretiva = { 
        bind(el,binding,vnode){ 
            console.log('teste: ',el)
        }
    }
    Vue.directive('nome-diretiva', nomeDiretiva)
*/

import Vue from 'vue'

export const dragModal = { // v-drag
  bind(el) {
    const contextmenu = el.querySelector('.modal-header') || el.children[0]
    let initX, initY, mousePressX, mousePressY

    contextmenu.style.cursor = 'move'
    contextmenu.addEventListener('mousedown', function(event) {
        
        let parent = this.parentElement
        initX = parent.offsetLeft
        initY = parent.offsetTop
        mousePressX = event.clientX
        mousePressY = event.clientY

        parent.addEventListener('mousemove', repositionElement, false)

        window.addEventListener('mouseup', function() {
            parent.removeEventListener('mousemove', repositionElement, false)
        }, false)

    }, false)

    function repositionElement(event) {
        this.style.left = initX + event.clientX - mousePressX + 'px'
        this.style.top = initY + event.clientY - mousePressY + 'px'
    }
  }
}
export default dragModal

Vue.directive('drag', dragModal);
